import { render, staticRenderFns } from "./DangerSSTRecommendation.vue?vue&type=template&id=d8b005f6"
import script from "./DangerSSTRecommendation.vue?vue&type=script&lang=js"
export * from "./DangerSSTRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports